import React, { useCallback } from "react";
import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import { usePlaylist } from "@hooks/trpc/usePlaylists";
import { useShare } from "@hooks/trpc/useShare";
interface PlaylistButtonsProps {
  iconSize: number;
  id: string;
  isPublic: boolean;
  type: "playlist";
}

const PlaylistButtonsComp = ({
  iconSize,
  id,
  isPublic,
}: PlaylistButtonsProps) => {
  const {
    query: { data: playlistsData },
  } = usePlaylist(id);
  const share = useShare();

  const canShareCollection =
    isPublic && !id.startsWith("liked_") && id !== "discover_daily";

  const handlePressShare = useCallback(() => {
    const playlist = playlistsData;
    if (!playlist) return;

    const directLink = {
      contentType: "playlist" as const,
      data: {
        id: playlist.id,
        title: playlist.title,
        user: {
          id: playlist.user?.id,
          name: playlist.user?.name,
        },
        imageUrl: playlist.images?.at(0) ?? null,
      },
    };

    share.mutate({
      linkType: "direct-link",
      ...directLink,
    });
  }, [playlistsData, share]);

  return (
    <>
      {canShareCollection && (
        <LPressable
          sentryEventName="share_collection"
          onPress={handlePressShare}
          disabled={share.isPending}
          style={{ opacity: share.isPending ? 0.5 : 1 }}
        >
          <LIcon name="share" size={iconSize} />
        </LPressable>
      )}
    </>
  );
};

const PlaylistButtons = ({
  iconSize,
  id,
  isPublic,
  type,
}: PlaylistButtonsProps) => {
  if (type !== "playlist" || !id) return null;
  return (
    <PlaylistButtonsComp
      iconSize={iconSize}
      id={id}
      isPublic={isPublic}
      type={type}
    />
  );
};

export default PlaylistButtons;
